$(function(){
    $(document).foundation();
});